import { resolveReportKind } from "./reportKindResolver";

const compactCustomerContext = (customerContext = {}) => {
  const compact = {
    name: customerContext?.name || null,
    niche: customerContext?.niche || null,
    brief: customerContext?.brief || null,
    interest: customerContext?.interest || null,
  };

  return Object.values(compact).some(Boolean) ? compact : null;
};

export const buildPromptReportContext = ({
  customerContext,
  dataSource,
  effectivePeriod,
  filters,
  financialData,
  language,
  reportType,
}) => ({
  reportType,
  reportKind: resolveReportKind(reportType, financialData),
  period: effectivePeriod || null,
  currency: filters?.currency || financialData?.overview?.currency || null,
  groupBy: filters?.groupBy || financialData?.overview?.group_by || null,
  uiLanguage: ["en", "english"].includes(String(language || "").toLowerCase()) ? "en" : "ar",
  outputLanguage: ["en", "english"].includes(String(language || "").toLowerCase())
    ? "English"
    : "Arabic",
  dataSource,
  customerContext: compactCustomerContext(customerContext),
});
